import Main from '@/views/administracion/configuracion/catalogos/tiposdocumentos/Main.vue';
import Default from '@/views/administracion/configuracion/catalogos/tiposdocumentos/Default.vue';

const auth = ['Catálogos:ver'];
const scopes = ['Catálogos:crear', 'Catálogos:editar', 'Catálogos:eliminar'];

const tiposDocumentos = [
  {
    path: 'tiposDocumentos',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'catalogoTiposDocumentos',
        path: '/',
        meta: {
          title: 'Tipos de Documentos',
          auth,
          scopes,
        },
        component: Default,
      },
    ],
  },
];

export default tiposDocumentos;
